import { Features, isFeatureEnabled } from '.';

export const BlockedByFeature = 'blocked-by-feature' as const;
export type BlockedByFeatureType = typeof BlockedByFeature;

interface INotAvailableExcept<E,> {
  expected: E;
  availableIn: ReadonlyArray<Features>;
}

export const notAvailablePropExceptIn = <E,>({ expected, availableIn }: INotAvailableExcept<E>): E | typeof BlockedByFeature => {
  const result = availableIn.some(feature => isFeatureEnabled(feature));
  return result ? expected : BlockedByFeature;
};
